import { render, staticRenderFns } from "./BatchOperateEditUA.vue?vue&type=template&id=f2a1f730&scoped=true"
import script from "./BatchOperateEditUA.vue?vue&type=script&lang=ts"
export * from "./BatchOperateEditUA.vue?vue&type=script&lang=ts"
import style0 from "./BatchOperateEditUA.vue?vue&type=style&index=0&id=f2a1f730&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2a1f730",
  null
  
)

export default component.exports